package ir.alirezaivaz.finglish.utils

class FinglishDictionary {
    private val words = mapOf(
        "من" to "man",
        "به" to "be",
        "که" to "ke",
        "در" to "dar",
        "شما" to "shoma",
        "نه" to "na",
        "هم" to "ham",
        "برای" to "baraye",
        "باید" to "bayad",
        "بود" to "bood",
        "کنم" to "konam",
        "نمی" to "nemi",
        "خیلی" to "kheili",
        "همه" to "hame",
        "کن" to "kon",
        "فقط" to "faghat",
        "شده" to "shode",
        "فکر" to "fekr",
        "اما" to "amma",
        "یک" to "yek",
        "خوب" to "khoob",
        "دارم" to "daram",
        "های" to "hay",
        "هر" to "har",
        "کنی" to "koni",
        "کنه" to "kone",
        "ولی" to "vali",
        "توی" to "tooy",
        "آره" to "are",
        "چرا" to "chera",
        "پس" to "pas",
        "شد" to "shod",
        "منو" to "menu",
        "وقتی" to "vaghti",
        "کردم" to "kardam",
        "دست" to "dast",
        "مثل" to "mesl",
        "هست" to "hast",
        "دوست" to "doost",
        "کنیم" to "konim",
        "اوه" to "oh",
        "بچه" to "bache",
        "بده" to "bede",
        "او" to "ou",
        "یه" to "ye",
        "بله" to "bale",
        "زندگی" to "zendegi",
        "کرد" to "kard",
        "بهت" to "behet",
        "برو" to "boro",
        "خوبه" to "khoobe",
        "بودم" to "boodam",
        "پیدا" to "peyda",
        "وقت" to "vaght",
        "هستم" to "hastam",
        "بیرون" to "biroon",
        "چیه" to "chie",
        "روز" to "rooz",
        "خب" to "khob",
        "تنها" to "tanha",
        "هنوز" to "hanooz",
        "اگر" to "agar",
        "کسی" to "kasi",
        "کنید" to "konid",
        "خونه" to "khoone",
        "آنها" to "anha",
        "بر" to "bar",
        "کرده" to "karde",
        "شاید" to "shaiad",
        "بهش" to "behesh",
        "حرف" to "harf",
        "همین" to "hamin",
        "بهم" to "behem",
        "درست" to "dorost",
        "بریم" to "berim",
        "کردن" to "kardan",
        "تمام" to "tamam",
        "سلام" to "salam",
        "همیشه" to "hamishe",
        "تونم" to "toonam",
        "هی" to "hey",
        "نظر" to "nazar",
        "دونم" to "doonam",
        "چند" to "chand",
        "وجود" to "vojood",
        "نگاه" to "negah",
        "یکی" to "yeki",
        "بیشتر" to "bishtar",
        "خیلی" to "kheili",
        "کنند" to "konand",
        "مورد" to "mored",
        "نداره" to "nadare",
        "دوباره" to "dobare",
        "روی" to "rooy",
        "کردی" to "kardi",
        "آقای" to "aghaye",
        "هستی" to "hasti",
        "صحبت" to "sohbat",
        "نمی" to "nemi",
        "خودت" to "khodet",
        "پدر" to "pedar",
        "شروع" to "shoroo",
        "سر" to "sar",
        "مرد" to "mard",
        "بشه" to "beshe",
        "بزرگ" to "bozorg",
        "خانم" to "khanom",
        "کجا" to "koja",
        "باید" to "bayad",
        "خاطر" to "khater",
        "هستند" to "hastand",
        "درسته" to "doroste",
        "صبر" to "sabr",
        "میکنم" to "mikonam",
        "کنم" to "konam",
        "میخوام" to "mikham",
        "بدون" to "bedoon",
        "واقعا" to "vaghean",
        "امروز" to "emrooz",
        "امروزی" to "emroozi",
        "تموم" to "tamoom",
        "خودم" to "khodam",
        "بگو" to "begu",
        "گوش" to "goosh",
        "منم" to "manam",
        "عزیزم" to "azizam",
        "آدم" to "adam",
        "کمک" to "komak",
        "چطور" to "chetor",
        "باشم" to "basham",
        "زمان" to "zaman",
        "بدم" to "bedam",
        "بدی" to "bedi",
        "پول" to "pool",
        "ممنون" to "mamnoon",
        "شدم" to "shodam",
        "زود" to "zood",
        "گفتم" to "goftam",
        "کم" to "kam",
        "خوبی" to "khubi",
        "دختر" to "dokhtar",
        "کن" to "kon",
        "نفر" to "nafar",
        "شب" to "shab",
        "خدا" to "khoda",
        "کند" to "kond",
        "گفت" to "goft",
        "شدن" to "shodan",
        "پسر" to "pesar",
        "فکر" to "fekr",
        "بوده" to "bude",
        "حتی" to "hatta",
        "برم" to "beram",
        "زیادی" to "ziadi",
        "قبل" to "ghabl",
        "هرگز" to "hargez",
        "استفاده" to "estefade",
        "میکنی" to "mikoni",
        "مردم" to "mardom",
        "دارن" to "daran",
        "همون" to "hamoon",
        "تونی" to "tooni",
        "البته" to "albate",
        "زمین" to "zamin",
        "سمت" to "samt",
        "آه" to "ah",
        "درباره" to "darbare",
        "اجازه" to "ejaze",
        "جنگ" to "jang",
        "تر" to "tar",
        "لعنتی" to "lanati",
        "ندارم" to "nadaram",
        "دور" to "door",
        "دنبال" to "donbal",
        "ازش" to "azash",
        "بگم" to "begam",
        "خودش" to "khodesh",
        "زنده" to "zende",
        "برای" to "baraye",
        "تونه" to "toone",
        "یاد" to "yaad",
        // TODO: Support "وا"
        "میخوای" to "mikhay",
        "آماده" to "amade",
        "متاسفم" to "motoaasefam",
        "قربان" to "ghorban",
        "چقدر" to "cheghadr",
        "اول" to "aval",
        "بودی" to "boodi",
        "مادر" to "madar",
        "خواهد" to "khahad",
        "نیستم" to "nistam",
        "داشتم" to "dashtam",
        "خواهش" to "khahesh",
        "قرار" to "gharar",
        "فرار" to "farar",
        "میدونی" to "miduni",
        "برات" to "barat",
        "منه" to "mane",
        "زن" to "zan",
        "میدونم" to "midunam",
        "مرگ" to "marg",
        "احساس" to "ehsas",
        "جایی" to "jaii",
        "مگه" to "mage",
        "بهتره" to "behtare",
        "هستن" to "hastan",
        "حمله" to "hamle",
        "دونی" to "dooni",
        "شهر" to "shahr",
        "بهترین" to "behtarin",
        "بهتر" to "behtar",
        "نگه" to "nage",
        "لطفا" to "lotfan",
        "نبود" to "nabood",
        "نباید" to "nabayad",
        "سعی" to "saay",
        "نجات" to "nejat",
        "هوا" to "hava",
        "هوایی" to "havaei",
        "استاد" to "ostad",
        "هنر" to "honar",
        "دلنواز" to "delnavaz",
        "گوینده" to "gooiande",
        "گویندگی" to "gooiandegi",
        "طرفدار" to "tarafdar",
        "پرطرفدار" to "portarafdar",
        "پرطرفدارترین" to "portarafdartarin",
        "اجتماعی" to "ejtemaei",
        "اقتصادی" to "eghtesadi",
        "اینترنت" to "internet",
        "اینترنتی" to "interneti",
        "اینترانت" to "interanet",
        "اطلاع" to "etela",
        "اطلاعات" to "etelaat",
        "ارتباط" to "ertebat",
        "ارتباطات" to "ertebatat",
        "جمع" to "jam",
        "جمعی" to "jamii",
        "توان" to "tavan",
        "گوشه" to "gooshe",
        "کاربرد" to "karbord",
        "کاربردی" to "karbordi",
        "گسترده" to "gostarde",
        "مرور" to "moroor",
        "تجربه" to "tajrobe",
        "حرفه" to "herfe",
        "حرفه‌ای" to "herfei",
        "توانند" to "tavanand",
        "صد" to "sad",
        "صدها" to "sadha",
        "هزار" to "hezar",
        "هزاران" to "hezaran",
        "کلمه" to "kalameh",
        "ارتکاب" to "ertekab",
        "اشتباه" to "eshtebah",
        "درس" to "dars",
        "درست" to "dorost",
        "بیان" to "bayan",
        "رسید" to "resid",
        "رسیدن" to "residan",
        "سطح" to "sath",
        "مهارت" to "maharat",
        "آموزش" to "amoozesh",
        "تمرین" to "tamrin",
        "لازم" to "lazem",
        "الزام" to "elzam",
        "الزامی" to "elzami",
        "التزام" to "eltezam",
        "متن" to "matn",
        "پخش" to "pakhsh",
        "توقف" to "tavaghof",
        "مکث" to "maks",
        "ادامه" to "edame",
        "مناسب" to "monaseb",
        "متناسب" to "motanaseb",
        "هدف" to "hadaf",
        "تقویت" to "taghviat",
        "صدا" to "seda",
        "تصویر" to "tasvir",
        "بازیگر" to "bazigar",
        "بازیگری" to "bazigari",
        "اجرا" to "ejra",
        "اجرای" to "ejraye",
        "لحن" to "lahn",
        "مختلف" to "mokhtalef",
        "همچنین" to "hamchenin",
        "همچنان" to "hamchenan",
        "فن" to "fan",
        "بهره" to "bahre",
        "ببرید" to "bebarid",
        "استان" to "ostan",
        "شهرستان" to "shahrestan",
        "شهر" to "shahr",
        "دهستان" to "dehestan",
        "روستا" to "roosta",
        "جنگل" to "jangal",
        "دشت" to "dasht",
        "دریا" to "daria",
        "خلیج" to "khalij",
        "رود" to "rood",
        "رودخانه" to "roodkhane",
        "کوه" to "kooh",
        "درخت" to "derakht",
        "سکته" to "sakte",
        "کیوی" to "kivi",
    )

    private val letters = mapOf(
        'آ' to "aa", 'ا' to "a", 'ب' to "b", 'پ' to "p",
        'ت' to "t", 'ث' to "s", 'ج' to "j", 'چ' to "ch",
        'ح' to "h", 'خ' to "kh", 'د' to "d", 'ذ' to "z",
        'ر' to "r", 'ز' to "z", 'ژ' to "zh", 'س' to "s",
        'ش' to "sh", 'ص' to "s", 'ض' to "z", 'ط' to "t",
        'ظ' to "z", 'ع' to "a", 'غ' to "gh", 'ف' to "f",
        'ق' to "gh", 'ک' to "k", 'گ' to "g", 'ل' to "l",
        'م' to "m", 'ن' to "n", 'و' to "o", 'ه' to "h",
        'ۀ' to "eye", 'ی' to "y", 'ء' to "'", 'ئ' to "y",
        'ؤ' to "o"
    )

    private val numbers = mapOf(
        '۰' to '0', '۱' to '1', '۲' to '2', '۳' to '3', '۴' to '4',
        '۵' to '5', '۶' to '6', '۷' to '7', '۸' to '8', '۹' to '9'
    )

    private val symbols = mapOf(
        '،' to ',', '؟' to '?', '؛' to ';', '٪' to '%', '«' to '"', '»' to '"'
    )

    private fun isVowel(c: Char): Boolean {
        return c in listOf('ا', 'آ', 'و', 'ی')
    }

    private fun applyDiacritic(c: Char): String? {
        return when (c) {
            '\u064E' -> "a"  // فتحه
            '\u064F' -> "o"  // ضمه
            '\u0650' -> "e"  // کسره
            '\u064B' -> "an" // تنوین فتح
            '\u064C' -> "on" // تنوین ضم
            '\u064D' -> "en" // تنوین کسر
            '\u0651' -> ""   // تشدید (نادیده‌گرفتن)
            '\u0652' -> ""   // سکون
            else -> null
        }
    }

    fun isPersianLetterOrMark(c: Char): Boolean {
        return c.isLetterOrDigit() || applyDiacritic(c) != null
    }

    private fun transliterateLetter(c: Char, index: Int, word: String): String {
        val prev = word.getOrNull(index - 1)
        val next = word.getOrNull(index + 1)

        return when (c) {
            'و' -> {
                when {
                    word.length == 1 -> "va"
                    index == 0 -> "v"
                    else -> "o"
                }
            }
            'ی' -> {
                when {
                    index == 0 -> "y"
                    // Between two vowels
                    prev != null && next != null && isVowel(prev) && isVowel(next) -> "y"
                    else -> "i"
                }
            }
            'ه' -> {
                val prev = word.getOrNull(index - 1)
                if (index == word.lastIndex) {
                    when {
                        word.length == 1 -> "h"
                        // After a vowel (like Mah)
                        prev != null && isVowel(prev) -> "h"
                        else -> "e"
                    }
                } else {
                    "h"
                }
            }
            else -> letters[c] ?: numbers[c]?.toString() ?: c.toString()
        }
    }

    fun normalize(c: Char): Char = when (c) {
        'ي' -> 'ی'
        'ك' -> 'ک'
        else -> c
    }

    fun getWord(word: String): String {
        words[word]?.let { return it }

        val result = StringBuilder()

        var i = 0
        while (i < word.length) {
            val c = word[i]

            val diacritic = applyDiacritic(c)
            if (diacritic != null) {
                if (result.isNotEmpty()) {
                    val lastCharIndex = result.length - 1

                    if (result[lastCharIndex] in listOf('a', 'e', 'o')) {
                        result.deleteAt(lastCharIndex)
                        result.append(diacritic)
                    } else {
                        result.append(diacritic)
                    }
                } else {
                    result.append(diacritic)
                }

                i++
                continue
            }

            if (i < word.lastIndex) {
                val next = word[i + 1]

                // A vowel + diacritic
                val nextDiacritic = applyDiacritic(next)
                if (c == 'ا' && nextDiacritic != null) {
                    result.append(nextDiacritic)
                    i += 2
                    continue
                }

                val pair = "$c$next"
                when (pair) {
                    "او" -> {
                        result.append("oo")
                        i += 2
                        continue
                    }

                    "ای" -> {
                        result.append("i")
                        i += 2
                        continue
                    }
                }
            }

            result.append(transliterateLetter(c, i, word))
            i++
        }

        return result.toString()
    }

    fun getSymbol(symbol: Char): Char {
        return symbols[symbol] ?: symbol
    }
}
